export default __webpack_public_path__ + "media/library-default.f1f820184035241bdbd318acceb714ac.webp";